import { render, staticRenderFns } from "./SLA.vue?vue&type=template&id=3188e709&scoped=true"
import script from "./SLA.vue?vue&type=script&lang=js"
export * from "./SLA.vue?vue&type=script&lang=js"
import style0 from "./SLA.vue?vue&type=style&index=0&id=3188e709&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188e709",
  null
  
)

export default component.exports